import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { myTransactions } from '../../Store/api/student';
import StudentNavbar from '../../components/StudentNavbar';
import { StudentDashboardSidebar } from '../../components/StudentDashboardSidebar';
import Notifications from '../../components/studentDashboard/Profile/Notifications';
import { SubjectSetting } from '../../components/studentDashboard/Profile/SubjectSetting';
import AccountInformation from '../../components/studentDashboard/Profile/AccountInformation';
import PersonalInformation from '../../components/studentDashboard/Profile/PersonalInformation';
import { PaymentInformation } from '../../components/studentDashboard/Profile/PaymentInformation';

export default function Profile() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(
      myTransactions({
        onSuccess: (res) => {
          setTransactions(res.data.data || []);
          setIsLoading(false);
        },
        onError: (error) => {
          console.error(error);
          setIsLoading(false);
        },
      })
    );
  }, [dispatch]);

  return (
    <div className='wrapper'>
      <StudentDashboardSidebar sideBarEvent={'profile'} />
      <div id='content'>
        <div className='content_dashborad_inner'>
          <StudentNavbar sideBarEvent='settings' />
          <div>
            <div className='main_section_content'>
              <div className='center_content center_content-student full_width'>
                <div className='d-flex' style={{ justifyContent: 'space-between' }}>
                  <div className='settings_wrapper'>
                    <div>
                      <PersonalInformation />
                      <AccountInformation />
                      <PaymentInformation transactions={transactions} isLoading={isLoading} />
                      <Notifications />
                    </div>
                    <div className='box_border_settings border-grey'>
                      <div className='settings_header'>
                        <h2>Done Learning?</h2>
                        <div className='settings_header'>
                          <p className='mb-0 editt cursor'></p>
                        </div>
                      </div>
                      <div className='setting_rows'>
                        <p className='key' style={{ width: '70%' }}>
                          Delete your account? This will permanently delete your account and your
                          data, in accordance with applicable law.
                        </p>
                        <p style={{ width: '20%' }}></p>
                        <p
                          className='value'
                          style={{
                            background: '#AE2604',
                            borderRadius: '100px',
                            cursor: 'pointer',
                            width: '115px',
                            textAlign: 'center',
                            padding: '4px 16px',
                            color: 'white',
                          }}
                        >
                          Delete
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='settings_wrapper' style={{ justifyContent: 'normal' }}>
                    <SubjectSetting />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
